import themeStyle from './themeStyle';

const themeColors = {
    [themeStyle.DARK]: '#2e3235',
    [themeStyle.LIGHT]: '#FFFFFF',
};

export default themeColors;
